<template>
    <div class="wrapper" v-if="joint">
        <div class="rating-text">{{ whoseJoint }} joint heeft een <span class="rating" v-html="parseRating(joint.rating)"></span> gekregen{{joint.rating >= 6 ? '!' : '..'}} {{parseRating(joint.rating) == '6,9' ? ';)' : ''}}</div>
        <div class="button" @click="handleButtonClick">{{ calculateText }}</div>
        <div v-if="isMyJoint" class="button" @click="handleShareButton">Kopieer link</div>
    </div>
</template>

<script>
import JSConfetti from 'js-confetti';

export default {
    name: 'RatedJoint',
    data() {
        return {
            id: this.$route.params.id,
            apiConnection: null,
            joint: null
        }
    },
    created() {
        this.getJoint()
    },
    methods: {
        parseRating(rating) {
            return rating.toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 1 })
        },
        handleButtonClick() {
            this.$router.push({ name: 'Form' })

            // bewerk joint

            // const data = {
            //     rating: 10
            // }

            // const connection = new XMLHttpRequest();
            // connection.open('POST', `http://localhost:3000/joints/edit/64dc33d2-d392-44f7-8b7f-5bd90d0d2bad`);
            // connection.setRequestHeader('Content-Type', 'application/json')
            // connection.send(JSON.stringify(data));
        },
        handleShareButton() {
            var text = `https://ratemyjoint.netlify.app${this.$route.fullPath}`;
            navigator.clipboard.writeText(text).then(function() {
                console.log('Async: Copying to clipboard was successful!');
            }, function(err) {
                console.error('Async: Could not copy text: ', err);
            });
        },
        getJoint() {
            if(!this.id) return

            this.apiConnection = new XMLHttpRequest();
            this.apiConnection.addEventListener("load", this.handleApiResponse);
            this.apiConnection.open('GET', `https://80.61.147.206:3000/joints/${this.id}`);
            this.apiConnection.setRequestHeader('Content-Type', 'application/json')
            this.apiConnection.send();
        },
        handleApiResponse(test) {
            const rawResponseData = this.apiConnection.response;
            if(!rawResponseData) return
            const responseData = JSON.parse(rawResponseData);
            
            this.joint = responseData;
        }
    },
    watch: {
        joint: function() {
            if(!this.joint || this.joint.rating < 8) return

            const jsConfetti = new JSConfetti()
            jsConfetti.addConfetti({
                emojis: ['🌿','🎉','🎊'],
                emojiSize: 50,
                confettiNumber: 30,
            })
        }
    },
    computed: {
        isMyJoint: function() {
            const registeredJointIds = localStorage.getItem('registeredJointIds')
            if(!registeredJointIds) return false
            return registeredJointIds.includes(this.id) ? true : false
        },
        calculateText: function() {
            return this.isMyJoint ? 'Bereken er nog een' : 'Bereken er ook een'
        },
        whoseJoint: function() {
            return this.isMyJoint ? 'Jouw' : 'Deze'
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    .rating-text {
        text-align: center;
    }

    .button {
        background-color: $weed-green;
        color: #ffffff;
        padding: 4px 14px;
        margin-top: 24px;
        border-radius: 14px;
        font-weight: 600;
        transition: transform .2s ease;
        user-select: none;
    }
    .button:active {
        transform: scale(0.94);
    }
}

</style>